import {useEffect, useState, forwardRef, useImperativeHandle} from "react";
import useMessage from "../../Hooks/useMessage";
import useExceptionHandler from "../../Hooks/useExceptionHandler";
import {actualizarInformacionCompania, obtenerCompania} from "../../../../Seguridad/Scripts/Services/companiaService"
import {Form, Card} from "react-bootstrap";
import EditHeader from "../../Componentes/PantallasEdit/Header/EditHeader";
import EditContainer from "../../Componentes/PantallasEdit/EditContainer/EditContainer";
import EditSection from "../../Componentes/PantallasEdit/EditSection/EditSection";
import SectionRow from "../../Componentes/PantallasEdit/SectionRow/SectionRow";
import InputContainer from "../../Componentes/PantallasEdit/InputContainer/InputContainer";
import {RncLookup} from "../../Componentes/Lookups/RncLookup";
import {ControlledInput} from "../../Componentes/Inputs/ControlledInput";
import {FECHA_CIERRE_FISCAL, PhoneFormat} from "../../Utils";
import Select from "react-select";
import {EmailInput, PhoneInput} from "../../Componentes";
import Direcciones from "../../Componentes/Direcciones/Direcciones";

export const MiCuentaEdit = forwardRef(
    ({
         showLoading,
         hideLoading,
         esModal,
         idSec,
     }, 
     ref
    ) => {
    
    const {cerrarAlertas, Message, Warning} = useMessage();  
    const {handleException} = useExceptionHandler();    
    const [compania, setCompania] = useState({});
    
    useEffect(() => {
        if(idSec && esModal){
            showLoading();
            cargarDatosCompania(idSec);
        }
        return () => {
            hideLoading();
            cerrarAlertas();
        };
    },[idSec])
        
    const cargarDatosCompania = (idSec) => {
        try {
            obtenerCompania({}).then((response) => {
                setCompania(response);
            })
            .catch((e) => {
                handleException(e);
            })
            .finally(() => hideLoading());
        }
        catch (e) {
            handleException(e);
        }
    }
    const grabar = async () => {
        try {
            showLoading();
            if(!validarCampos(compania)){
                return false;
            }

            const response = await actualizarInformacionCompania({compania: {...compania}});
            Message({messages: [response]});
            return true;
        }
        catch (e) {
            handleException(e);
            return false;
        }
        finally {
            hideLoading();
        }
    }
    
    const validarCampos = (compania) => {
        let messages = [];
        if(compania.RNC){
            var parsedRNC = parseInt(compania.RNC.trim())
            if(isNaN(parsedRNC)) 
            {
                messages.push("Campo Documento tiene un formato invalido.")
            }
            if(compania.RNC.length !== 9 && compania.RNC.length !== 11 )
            {
                messages.push("Campo Documento debe contener 9 u 11 caracteres.")
            }
        }
        if(!compania.Nombre || compania.Nombre === ""){
            messages.push("Campo Nombre es requerido")
        }
        if(!compania.Email || compania.Email === ""){
            messages.push("Campo Correo es requerido")
        }
        if(!compania?.Telefonos?.length > 0){
            messages.push("Campo Teléfono es requerido")
        }
        else {
            if(!compania?.Telefonos[0]?.Telefono || compania?.Telefonos[0]?.Telefono === ""){
                messages.push("Campo Teléfono es requerido")
            }else{
                if(!PhoneFormat.isValid(PhoneFormat.formatPhone(compania.Telefonos[0].Telefono))){
                    messages.push("Campo Teléfono incorrecto")
                }
            }
            if(compania?.Telefonos[1]){
                if(!PhoneFormat.isValid(PhoneFormat.formatPhone(compania.Telefonos[1].Telefono))){
                    messages.push("Campo Teléfono incorrecto")
                }
            }
        }
        if (messages.length > 0) {
            Warning({ messages: messages });
        }
        return messages.length === 0;
    }
    
    useImperativeHandle(ref, () => ({
        grabar,
    }));
    
    return (
        <Form action="" className="form-horizontal" id="TypeValidation" method="">
            <EditHeader 
                titulo={"Información de la compañía"}
                volver={true}
                showLoading={showLoading}
                hideLoading={hideLoading}
                esModal={esModal}
                grabar={grabar}
            />
            <EditContainer>
                <EditSection title={"Información General"}>
                    <SectionRow>
                        <InputContainer label="Documento">
                            <RncLookup
                                placement={'end'}
                                isInput={false}
                                initialValue={{ value: compania?.RNC }}
                                onChange={(e) =>
                                    setCompania({
                                        ...compania,
                                        RNC: e.value,
                                        RazonSocial: e.nombre || compania.RazonSocial
                                    })
                                }
                            />
                        </InputContainer>
                        <ControlledInput
                            required
                            label="Nombre"
                            name="Nombre"
                            type="text"
                            setState={setCompania}
                            value={compania?.Nombre  || ""}
                        />
                    </SectionRow>
                    <SectionRow>
                        <InputContainer label="Teléfono">
                            <PhoneInput
                                required
                                hideExt
                                hideType
                                initialValue={compania?.Telefonos}
                                maxCount={2}
                                onChange={(tels) =>
                                    setCompania({
                                        ...compania,
                                        Telefonos: tels,
                                    })
                                }
                            />
                        </InputContainer>
                        <InputContainer label="Correo">
                            <EmailInput
                                required
                                maxCount={1}
                                placeholder="Correo Electrónico"
                                inputValue={compania?.Email}
                                parentCallback={(e) => {
                                    setCompania({
                                        ...compania,
                                        Email: e,
                                    });
                                }}
                            />
                        </InputContainer>
                    </SectionRow>
                    <SectionRow>
                        <InputContainer label="Cierre Fiscal">
                            <Select
                                className="react-select primary"
                                classNamePrefix="react-select"
                                name="Cierre Fiscal"
                                onChange={(e) => {
                                    setCompania({
                                        ...compania,
                                        cierreFiscal: e.value,
                                    })
                                }
                                }
                                options={FECHA_CIERRE_FISCAL}
                                value={
                                    !compania?.cierreFiscal
                                        ? FECHA_CIERRE_FISCAL.filter(function (option) {
                                            return option.value === "A";
                                        })
                                        : FECHA_CIERRE_FISCAL.filter(function (option) {
                                            return option.value === (compania?.cierreFiscal || "A");
                                        })
                                }
                            />
                        </InputContainer>
                    </SectionRow>
                </EditSection>
                <Direcciones
                    sectionLabel='Dirección'
                    posicionCanvas ={'end'}
                    initialValue={compania?.Direcciones}
                    onChange={(e) => {
                        setCompania((prev) => ({
                            ...prev,
                            Direcciones: e,
                        }));
                    }}
                />
            </EditContainer>
        </Form>
    )
})
